import {
  FilterCopyTaskParameters,
  LayerTaskDataStorage,
  SchedulerTask,
  TableTaskDataStorage,
  TaskDataType,
} from "../../../interfaces/scheduler";

export type FilterCopyTask<T extends TaskDataType = TaskDataType> = T extends TaskDataType.Table
  ? FilterCopyTaskParameters<TableTaskDataStorage>
  : FilterCopyTaskParameters<LayerTaskDataStorage>;

// eslint-disable-next-line max-lines-per-function
export function createFilterCopyTask<T extends TaskDataType>({
  sourceName,
  targetName,
  geometryName,
  condition,
  reserveGeometryFilter,
  dataStorage,
}: {
  sourceName: string;
  targetName: string;
  geometryName?: string;
  reserveGeometryFilter?: boolean;
  condition?: string;
  dataStorage: T;
}): FilterCopyTask<T> {
  const baseTask: Omit<FilterCopyTaskParameters, "source" | "target"> = {
    condition: condition || void 0,
    type: condition ? SchedulerTask.FilterCopy : SchedulerTask.Copy,
    reverseGeometryFilter: reserveGeometryFilter,
  };

  switch (dataStorage) {
    case TaskDataType.Table: {
      const layerFilterCopyTask: FilterCopyTask<TaskDataType.Table> = {
        ...baseTask,
        source: {
          tableName: sourceName,
          type: dataStorage,
        },
        geometryFilterStorage: geometryName
          ? {
              // TODO
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              tableName: geometryName,
              type: dataStorage,
            }
          : void 0,
        target: {
          tableName: targetName,
          type: dataStorage,
        },
      };

      return layerFilterCopyTask as unknown as FilterCopyTask<T>;
    }
    default: {
      const tableFilterCopyTask: FilterCopyTask<TaskDataType.Layer> = {
        ...baseTask,
        source: {
          serviceName: sourceName,
          type: dataStorage,
          createNewService: false,
        },
        geometryFilterStorage: geometryName
          ? {
              serviceName: geometryName,
              type: dataStorage,
            }
          : void 0,
        target: {
          createNewService: false,
          serviceName: targetName,
          type: dataStorage,
        },
      };

      return tableFilterCopyTask as unknown as FilterCopyTask<T>;
    }
  }
}
